import Menu from '@/components/ui/menu/menu';
export default Menu;
